import { getAccessToken } from '../context';
import axios from 'axios';
import { sleep } from '../util/sleep';

const cache = {};
const promises = {};

export async function fetchWithPromise(key, path, params) {
  // Return existing promise if available
  if (promises[key]) {
    return promises[key];
  }

  // Else, fetch the data
  promises[key] = fetchFromServer(path, params);

  const result = await promises[key];
  delete promises[key];

  return result;
}

export async function fetchWithCache(key, path, params) {
  // Return from cache if available
  if (cache[key]) {
    return cache[key];
  }

  // Return existing promise if available
  if (promises[key]) {
    return promises[key];
  }

  // Else, fetch the data
  promises[key] = fetchFromServer(path, params);

  try {
    const result = await promises[key];
    if (!result.errorMessage) {
      cache[key] = result;
    }
    return result;
  } finally {
    delete promises[key];
  }
}

async function fetchFromServer(path, params, retries = 4) {
  try {
    const url = `${process.env.REACT_APP_HEAVYSET_API}/${path}`;
    const response = await axios.get(url, {
      params: params || {},
      headers: {
        Authorization: `Bearer ${getAccessToken()}`
      }
    });
    const data = response.data;
    return { data };
  } catch (ex) {
    const status = ex.response?.status;
    const shouldRetryAll = status === 502 || status === 503 || ex.message.includes('ECONNRESET') || !status;
    if (retries > 0) {
      await sleep(500);
      return await fetchFromServer(path, params, shouldRetryAll ? retries - 1 : 0);
    }
    if (ex.response?.data?.statusCode === 401) {
      console.log('TODO, logout, login or forward to contact page');
    }
    return { errorMessage: ex.response?.data?.message || ex.message };
  }
}
